export const FRESHDESK_AGENT_BASE_URL = "https://smartgridsolutions.freshdesk.com";

/**
 * FD-prefixed purchase orders map to an existing Freshdesk ticket id (digits after FD, before suffix).
 * Example: FD30742-2 → ticket 30742.
 */
export function freshdeskTicketIdFromPurchaseOrder(purchaseOrderNumber: string): number | null {
  const trimmed = purchaseOrderNumber.trim();
  const match = /^FD(\d+)/i.exec(trimmed);
  if (!match) {
    return null;
  }
  const ticketId = Number.parseInt(match[1], 10);
  return Number.isFinite(ticketId) && ticketId > 0 ? ticketId : null;
}

export function freshdeskContactUrl(contactId: number): string {
  return `${FRESHDESK_AGENT_BASE_URL}/a/contacts/${contactId}`;
}

/** Agent portal URL for a specific Freshdesk ticket (new tab). */
export function freshdeskTicketUrl(ticketId: number): string {
  return `${FRESHDESK_AGENT_BASE_URL}/a/tickets/${ticketId}`;
}

/**
 * Agent portal link for a purchase order: direct ticket when FD-prefixed, otherwise ticket search.
 * Operators must already be signed in to Freshdesk.
 */
export function freshdeskPurchaseOrderAgentUrl(purchaseOrderNumber: string): string {
  const ticketId = freshdeskTicketIdFromPurchaseOrder(purchaseOrderNumber);
  if (ticketId !== null) {
    return freshdeskTicketUrl(ticketId);
  }
  return freshdeskTicketSearchUrl(purchaseOrderNumber);
}

/**
 * Agent portal URL that opens ticket search with the term pre-filled (new tab).
 * Operators must already be signed in to Freshdesk.
 */
export function freshdeskTicketSearchUrl(searchTerm: string): string {
  const trimmed = searchTerm.trim();
  if (!trimmed) {
    return `${FRESHDESK_AGENT_BASE_URL}/a/search/tickets`;
  }
  const term = encodeURIComponent(trimmed);
  return `${FRESHDESK_AGENT_BASE_URL}/a/search/tickets?term=${term}`;
}

export function purchaseOrderNumbersFromPreview(poNumbers: string[] | undefined, poNumber: string): string[] {
  if (poNumbers && poNumbers.length > 0) {
    return poNumbers.map((value) => value.trim()).filter((value) => value.length > 0);
  }
  return [...new Set(
    poNumber
      .split(",")
      .map((part) => part.trim())
      .filter((part) => part.length > 0),
  )];
}
